import React from "react";
import linkdin from "../../../public/static/images/png/social-icons/linkdin.png";
import facebook from "../../../public/static/images/png/social-icons/facebook.png";
import twitter from "../../../public/static/images/png/social-icons/twitter.png";
import whatsapp from "../../../public/static/images/png/social-icons/whatsapp.png";
import line from "../../../public/static/images/png/social-icons/line.png";
import copy from "../../../public/static/images/png/social-icons/copy.png";
import copyToClipboard from "../../utils/copy-to-clipboard";
import ToastBar from "../UserInterface/ToastBar";

type SocialMediaShareBarProps = {
  title?: string;
  WidthAuto?: boolean;
  alignLeft?: boolean;
};

const SocialMediaShareBar = ({
  title,
  WidthAuto = false,
  alignLeft = false
}: SocialMediaShareBarProps) => {
  const isClient = typeof window === "object";

  const handleSocial = (socialMediaType) => {
    const hrefMap = {
      linkdin: `https://www.linkedin.com/shareArticle?mini=true&summary=${title}&source=homecredit&url=`,
      facebook: `https://www.facebook.com/dialog/share?app_id=87741124305&message=${title}&href=`,
      twitter: `https://twitter.com/intent/tweet?text=${title}&url=`,
      instagram: "",
      whatsapp: `whatsapp://send?text=${title} `,
      line: `https://line.me/R/msg/text/?${title} `
    };
    const utmMap = {
      linkdin: "?utm_source=linkedin%26utm_medium=share",
      facebook: "?utm_source=facebook%26utm_medium=share",
      twitter: "?utm_source=twitter%26utm_medium=share",
      whatsapp: "?utm_source=whatsapp%26utm_medium=share",
      line: "?utm_source=line%26utm_medium=share"
    };

    if (isClient) {
      const url = window.location.href;
      window.open(
        `${hrefMap[socialMediaType]}${url}${utmMap[socialMediaType]}`,
        "_blank"
      );
    }
  };

  return (
    <div className={"socmed-share-wrapper" + (WidthAuto ? " width-auto" : "")}>
      <img
        className="icon-social"
        src={linkdin}
        alt={"linkdin icons"}
        onClick={() => handleSocial("linkdin")}
      />
      <img
        className="icon-social"
        src={facebook}
        alt={"facebook icons"}
        onClick={() => handleSocial("facebook")}
      />
      <img
        className="icon-social"
        src={twitter}
        alt={"twitter icons"}
        onClick={() => handleSocial("twitter")}
      />
      {/* <img
          className="icon-social"
          src={instagram}
          alt={"instagram icons"}
          onClick={() => handleSocial("instagram")}
        /> */}
      <img
        className="icon-social"
        src={whatsapp}
        alt={"whatsapp icons"}
        onClick={() => handleSocial("whatsapp")}
      />
      <img
        className="icon-social"
        src={line}
        alt={"line icons"}
        onClick={() => handleSocial("line")}
      />
      <img
        className="icon-social"
        src={copy}
        alt={"copy icons"}
        onClick={() => copyToClipboard(window.location.href)}
      />
      <ToastBar> Link copied to clipboard </ToastBar>

      <style jsx>{`
        .socmed-share-wrapper {
          display: flex;
          justify-content: ${alignLeft ? "flex-start" : "space-around"};
          margin-left: ${alignLeft ? 0 : "auto"};
          margin-right: ${alignLeft ? 0 : "auto"};
          width: ${alignLeft ? "auto" : "25%"};
        }
        .width-auto {
          margin: 0;
          width: auto;
          justify-content: end;
        }
        .icon-social {
          margin: 12px 18px;
          height: 32px;
          cursor: pointer;
        }
        @media only screen and (max-width: 600px) {
          .socmed-share-wrapper {
            width: auto;
            margin: ${alignLeft ? "0 16px" : "0 24px"};
            justify-content: flex-start;
          }
          .socmed-share-wrapper img:not(:last-child) {
            margin-right: 12px;
          }
          .icon-social {
            margin: unset;
          }
        }
      `}</style>
    </div>
  );
};

export { SocialMediaShareBar };
